<template>
  <div class="dialog-size-md rejection-reason-dialog">
    <h1>{{ $t('PUBLISHING.DETAIL.POS.REJECTION_REASON.LABEL') }}</h1>
    <p>{{ $t('DESIGNS.STATUS.REJECTED_HINT') }}</p>
    <!-- <a href="mailto:verify@spreadshirt.co.uk" class="link-main"
      >verify@spreadshirt.co.uk</a
    > -->
    <h4>{{ $t(name) }}</h4>
    <!-- <p>{{ $t(description) }}</p> -->
    <SmartFaqLink :link="smartFaqLinks.REJECTION_HELP" class="help-link" />
  </div>
</template>

<script>
import SmartFaqLink from 'commons/helpLink/SmartFaqLink.vue';
import smartFaqLinks from 'commons/smartFaq/smartFaqLinks';
import {
  rejectionReasonName,
  rejectionReasonDescription,
} from 'commons/api/models/publishingCore/publishingCore';

export default {
  name: 'RejectionReasonDialog',
  components: {
    SmartFaqLink,
  },
  props: {
    modalInstance: { type: Object, required: true },
    data: { type: Object, required: true },
  },
  data() {
    return {
      smartFaqLinks,
    };
  },
  computed: {
    name() {
      return rejectionReasonName(this.data.reason);
    },
    description() {
      return rejectionReasonDescription(this.data.reason);
    },
  },
};
</script>

<style lang="scss" scoped>
@import 'src/scss/styleguide/colors';

.rejection-reason-dialog {
  h1 {
    margin: 0 0 12px 0;
  }

  h4 {
    margin: 24px 0 8px 0;
    color: $pa-color-red;
  }

  p {
    margin: 0 0 8px 0;
    color: $grey65;
  }

  .help-link {
    margin-top: 16px;
  }
}
</style>
